import axios from 'axios'

export const SESSION_TIMEOUT_EVENT = 'rs-session-timeout'
export const SESSION_TIMEOUT_CODES = new Set(['SESSION_TIMEOUT', 'SESSION_EXPIRED', 'SESSION_INVALID'])

export function isSessionTimeoutError(error) {
  const code = error?.response?.data?.code
  return error?.response?.status === 401 && SESSION_TIMEOUT_CODES.has(code)
}

/** True when the server rejected credentials (not rate limit / 5xx / network). */
export function isAuthFailureError(error) {
  if (isSessionTimeoutError(error)) return false
  const status = error?.response?.status
  return status === 401 || status === 403
}

export function isTransientAuthError(error) {
  if (!error?.response) return true
  const status = error.response.status
  return status === 429 || status >= 500
}

export function emitSessionTimeout() {
  sessionStorage.setItem('rs_session_expired', '1')
  window.dispatchEvent(new CustomEvent(SESSION_TIMEOUT_EVENT))
}

export function clearSessionExpiredFlag() {
  sessionStorage.removeItem('rs_session_expired')
}

export function isSessionExpiredFlagSet() {
  return sessionStorage.getItem('rs_session_expired') === '1'
}

let installed = false

export function setupAxiosSessionTimeoutInterceptor() {
  if (installed) return
  installed = true
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (isSessionTimeoutError(error)) {
        emitSessionTimeout()
      }
      return Promise.reject(error)
    }
  )
}
